'use client';

import { useEffect, useState } from 'react';

export default function StepProgress({ steps, extendLine = false }) {
  const [stepProgress, setStepProgress] = useState(0);
  const lineHeight = extendLine ? 'calc(100% + 5rem)' : '100%';
  const progressHeight =
    extendLine && stepProgress >= 100 ? lineHeight : `${stepProgress}%`;

  useEffect(() => {
    const handleScroll = () => {
      const stepElements = document.querySelectorAll('[data-step]');
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      
      let currentStep = 0;
      stepElements.forEach((element, index) => {
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top + scrollY;
        
        if (scrollY + windowHeight / 2 >= elementTop) {
          currentStep = index + 1;
        }
      });
      
      setStepProgress((currentStep / steps.length) * 100);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [steps.length]);

  return (
    <div className="relative border-l-2 border-gray-300 dark:border-gray-600 ml-8 pl-10 md:ml-6 md:pl-12 space-y-12">
      {/* Static background line */}
      <div className="absolute left-0 w-1 bg-gray-300 dark:bg-gray-600" style={{top: '-4px', height: lineHeight}}></div>
      {/* Animated progress line */}
      <div 
        className="absolute left-0 w-1 bg-gradient-to-b from-yellow-500 via-yellow-400 to-yellow-600 transition-all duration-700 ease-out" 
        style={{
          top: '-4px', // Start exactly at the top of the first circle
          height: progressHeight
        }}
      ></div>
      {steps.map((item, index) => (
        <div key={index} className="relative" data-step={index + 1}>
          <div className="absolute -left-[3.75rem] -top-2 flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-2xl font-black text-white shadow-xl shadow-blue-950/20 ring-[6px] ring-blue-100 transition-all duration-300 hover:scale-110 dark:ring-blue-900/50 md:-left-[4.5rem] md:h-16 md:w-16 md:text-3xl">
            {item.step}
          </div>
          <div className="bg-white dark:bg-gray-800 p-7 md:p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <h3 className="text-2xl font-black mb-3 text-gray-900 dark:text-yellow-500">
              {item.title}
            </h3>
            <p className="text-base leading-relaxed text-gray-700 dark:text-gray-300 md:text-lg" dangerouslySetInnerHTML={{ __html: item.description }} />
          </div>
        </div>
      ))}
    </div>
  );
}
